import {
  useListActivePresentationFormByCongressIdQuery,
  useListActivePresentationTopicByCongressIdQuery,
  useGetActivePresentationInfoByCongressIdQuery,
  useListPresentationFormByCongressIdQuery,
  useListPresentationTopicByCongressIdQuery,
} from "../store/presentation/presentation";
import { PreviewDropdownItem } from "../components/common/PreviewDropdown";
import { Presentation } from "../types/presentation.types";

interface UsePresentationsQueryResult {
  forms: PreviewDropdownItem[];
  topics: PreviewDropdownItem[];
  extraInfo: Presentation | undefined;
  areFormsLoading: boolean;
  areTopicsLoading: boolean;
}

export const usePresentationsQuery = (
  congressId: number,
  isEditMode: boolean
): UsePresentationsQueryResult => {
  const formsPublicQuery = useListActivePresentationFormByCongressIdQuery(
    congressId,
    {
      skip: isEditMode,
    }
  );
  const formsHiddenQuery = useListPresentationFormByCongressIdQuery(
    congressId,
    {
      skip: !isEditMode,
    }
  );

  const topicsPublicQuery = useListActivePresentationTopicByCongressIdQuery(
    congressId,
    {
      skip: isEditMode,
    }
  );
  const topicsHiddenQuery = useListPresentationTopicByCongressIdQuery(
    congressId,
    {
      skip: !isEditMode,
    }
  );

  const extraInfoPublicQuery = useGetActivePresentationInfoByCongressIdQuery(
    congressId,
    {
      skip: isEditMode,
    }
  );
  const extraInfoHiddenQuery = useGetActivePresentationInfoByCongressIdQuery(
    congressId,
    {
      skip: !isEditMode,
    }
  );

  const forms = isEditMode
    ? (formsHiddenQuery.data ?? []).map((presentation) => ({
        id: presentation.id,
        leftText: presentation.name,
        rightText: !presentation.enabled ? "inactive" : undefined,
      }))
    : formsPublicQuery.data ?? [];
  const topics = isEditMode
    ? (topicsHiddenQuery.data ?? []).map((presentation) => ({
        id: presentation.id,
        leftText: presentation.name,
        rightText: !presentation.enabled ? "inactive" : undefined,
      }))
    : topicsPublicQuery.data ?? [];
  const extraInfo = isEditMode
    ? extraInfoHiddenQuery.data
    : extraInfoPublicQuery.data;

  const areFormsLoading = isEditMode
    ? formsHiddenQuery.isLoading
    : formsPublicQuery.isLoading;
  const areTopicsLoading = isEditMode
    ? topicsHiddenQuery.isLoading
    : topicsPublicQuery.isLoading;

  return {
    forms,
    topics,
    extraInfo,
    areFormsLoading,
    areTopicsLoading,
  };
};
